<section class="main-page page-shipment-details">
  <section class="section-your-host">
    <div class="shipment-details-your-host-section-partners-wrapper">
      <div class="container shippn-homepage-container shipment-details-page-wrapper">
        <div class="row">
          <div class="col-md-12">
            <div class="shipment-details-carrier-options-and-delivery-information">
              <h4>
                Your products will be delivered within 1-5 business days via express shipping. In partnership with best
                couriers.</h4>

              <div class="carrier-list">
                <i><img width="70px"
                    style="margin-left:-20px; margin-right: -17px;padding-left: 4px;padding-right: 4px;"
                    src="../../assets/ups.png" alt="ups logo"></i>
                <i><img width="75px" style="padding-left: 4px;padding-right: 4px;" src="../../assets/dhl.png"
                    alt="dhl logo"></i>
                <i><img width="75px" style="padding-left: 4px;padding-right: 4px;" src="../../assets/fedex.png"
                    alt="fedex logo"></i>
                <i><img width="75px" style="padding-left: 4px;padding-right: 4px;" src="../../assets/auspost.png"
                    alt="auspost logo"></i>

              </div>


            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="shippnpilot-main-wrapper">
      <app-shippnpilot-widget></app-shippnpilot-widget>
    </div>


  </section>

  <section class="section-items-and-shipment-details">
    <div class="container shippn-homepage-container shipment-details-page-wrapper">
      <div class="row">
        <div class="col-12 grid-2-column">

          <section class="section-item-details">

            <div class="row">
              <div class="col-md-12">
                <h1 class="shippn-page-title">
                  Item Details
                </h1>
              </div>
            </div>
            <div class="row">
              <div class="col-12" id="addProductArea">
                <p style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 400;margin-bottom: 8px;">
                  Please copy and paste the <strong>item link</strong> you wish to purchase <sub
                    style="color: #ff6c36;">*Required</sub></p>
                <div class="orderLinkInput-wrapper shipment-details-input-group">
                  <input style="width: 100%" type="text" [(ngModel)]="productLinkNgModel"
                    [ngClass]="{'shippn-border-red':!productLinkNgModel || productNeeded}"
                    placeholder="{{orderLinkPlaceholder}}" (click)="productNeeded = false;"
                    class="form-control form-control-sm shippn-input" [attr.data-cy]="'packageOrderUrl'"
                    (input)="removeWhitespace($event)">
                </div>
                <div class="adding-order-wrapper">

                  <div class="shipment-details-dimension-input-group width-100p">
                    <label class="shippn-form-label shippn-shipment-details-form-label">
                      Value of items
                    </label>
                    <div class="shipment-details-input-group input-group">
                      <input [(ngModel)]="productAmountNgModel" (focusout)="checkValue($event)" min="0" type="text" pattern="\d+(\.\d{1,2})?"
                        onchange="(function(el){el.value.replace(/[^0-9.,]/g, '');el.value=parseFloat(el.value).toFixed(2); el.value.replace(',', '.');})(this)"
                        (keydown)="checkKey($event)"
                        (paste)="onPaste($event)"
                         step="0.01" [ngClass]="{'shippn-border-red':!productAmountNgModel}"
                        placeholder="0.00" class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                      <div class="input-group-append">
                        <span class="input-group-text currency-input-append">
                          <span *ngIf="form.controls.valueOfItemsCurrency.value == 'USD'">$</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <button mat-flat-button color="primary"
                    class="shippn-mat-btn shipment-detail-add-link-btn shippn-shipments-detail-blue"
                    (click)="addProductLink()">Add Item</button>
                </div>
              </div>
              <div class="col-12" style="margin-top: 30px;">
                <h6>List of Added Products ({{orderLinksList?.size}} / 10)</h6>
                <div class="order-links-list-wrapper" [ngClass]="orderLinksList.size === 0 ? 'no-item-list': ''">


                  <div *ngIf="orderLinksList?.size === 0" class="empty-order-links-list-preview">

                    <img src="/assets/img/no-product-image.png" alt="empy box">
                    <h6>The products you added will be listed here.</h6>

                  </div>


                  <div class="order-links-list-item" *ngFor="let productLink of orderLinksList; let i = index;">
                    <div>
                      <p class="order-links-list-item-index">
                        {{i+1}}
                      </p>

                    </div>
                    <div class="og-detail-image-of-product">
                      <img src="{{productLink?.image}}" alt="">
                    </div>
                    <div>
                      <p class="order-links-list-item-product-link">
                        <span *ngIf="!productLink?.name">{{productLink?.url}}</span>
                        <span *ngIf="productLink?.name">{{productLink?.name}}</span>
                      </p>
                    </div>
                    <div class="order-links-list-item-actions">
                      <button data-toggle="modal" data-target="#editProduct" class="product-link-edit-item"
                        (click)="selectProduct(productLink)">
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button data-toggle="modal" data-target="#deleteProduct" class="product-link-remove-item"
                        (click)="selectProduct(productLink)">
                        <i class="far fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="total-declared-value-wrapper">
                  <h6 class="total-declared-value-title">
                    Total Declared Value
                  </h6>
                  <h6 class="total-declared-value-amount">
                    {{totalDeclaredValueAmount | number:'1.2-2'}} USD
                  </h6>

                </div>
              </div>

              <div class="col-12 payment-validation-for-desktop" style="margin-top: 30px;" id="paymentValidationArea">

                <p style="color:#3d3d3d; font-weight: 600; margin: 0 0 10px; font-size: 15px;">
                  Payment Validation
                </p>
                <div [ngClass]="isPaymentValidation ? 'verified-payment-validation': ''">
                  <p style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 300;margin-bottom: 10px;"
                    *ngIf="isPaymentValidation == true">
                    You have a verified payment method. You can continue and get the host’s address.</p>

                  <p style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 300;margin-bottom: 10px;">
                    You won’t be charged now. You will pay the shipping fee
                    after the package arrives at your host’s address.<br>
                  </p>
                </div>


                <div class="item-details-section-payment-validation-methods-wrapper"
                  *ngIf="isPaymentValidation == false" [ngClass]="{'element-3v': !browserIsFirefox,
                  'element-2v': browserIsFirefox}">


                  <div class="item-details-section-payment-validation-methods-wrapper-credit-card"
                    [ngClass]="paymentValidationNeeded ? 'with-red-border': ''">
                    <button (click)="isPaypal = false; isExpress = false; isCreditCard = true; paymentValidationNeeded = false;"
                      [ngClass]="isCreditCard == true ? 'active' : ''" class="radio-inlie payment-method-radio"
                      data-toggle="modal" data-target="#addCardStartingModal" id="addCardSectionButton"></button>
                    <span style="cursor: pointer; font-size: 14px;"
                      (click)="isPaypal = false; isExpress = false; isCreditCard = true; paymentValidationNeeded = false;"
                      data-toggle="modal" data-target="#addCardStartingModal" id="addCardSectionButton">Credit Card <i class="fas fa-credit-card" style="color:#f69e1a;"></i>
                    </span>
                  </div>

                  <div class="item-details-section-payment-validation-methods-wrapper-paypal"
                    [ngClass]="paymentValidationNeeded ? 'with-red-border': ''">
                    <button (click)="isPaypal = true; isExpress = false; isCreditCard = false; paymentValidationNeeded = false;"
                      [ngClass]="isPaypal == true ? 'active' : ''" class="radio-inlie payment-method-radio"></button>
                    <span (click)="isPaypal = true; isExpress = false; isCreditCard = false; paymentValidationNeeded = false;"
                      style="cursor: pointer;"><img src="assets/img/svg-original-colors/payment-paypal.svg" alt="" width="60px"></span>
                  </div>

                  <div class="item-details-section-payment-validation-methods-wrapper-paypal"
                  [ngClass]="{
                    'with-red-border': paymentValidationNeeded
                  }" *ngIf="!browserIsFirefox">
                    <button (click)="isExpress = true; isPaypal = false; isCreditCard = false; paymentValidationNeeded = false;"
                      [ngClass]="isExpress == true ? 'active' : ''" class="radio-inlie payment-method-radio"></button>
                    <span (click)="isExpress = true; isPaypal = false; isCreditCard = false; paymentValidationNeeded = false;"
                      style="cursor: pointer; display: flex; align-items: center; gap:10px;">
                      <img src="assets/img/svg-original-colors/gpay.svg" alt="" height="15px">
                      <div class="divider-black"></div>
                      <img src="assets/img/svg-original-colors/link_logo.png" alt="" height="15px">
                      </span>
                  </div>

                </div>

                <div class="item-details-section-payment-validation-method-selected-wrapper"
                  [ngClass]="isPaymentValidation == false && (isPaypal || isCreditCard || isExpress) ? '' : 'hidden'">



                  <div class="row" [ngClass]="isCreditCard ? '':'hidden'">
                    <!-- Verification Area -->
                    <div class="col-md-12" style="margin-left: auto;margin-right: auto;"
                      *ngIf="forViewSelectedCard != null && forViewSelectedCard.status != 3">
                      <p style="padding: 0; font-size: 14px;"
                        [ngClass]="{'hide': forViewSelectedCard?.status == 4 || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2) || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2)}">
                        <span style="color:#3aa23c; font-size: 16px;">You have added a new card.</span> <br />
                        We need to verify this card before it can be used on Shippn. <br />
                        We have charged <strong translate="no">$0.50</strong> to this card.
                        <br /> <br />
                        You will see this charge as <strong translate="no">"SHIPPN* XXXX-CODE"</strong> on your credit
                        card
                        statement.
                      </p>
                      <!-- Verification Box -->
                      <div *ngIf="forViewSelectedCard != null && forViewSelectedCard.status != 3" style="padding: 0;">
                        <div class="row">
                          <div class="col-md-12 verification-box-mobile-width-fixer">
                            <div>
                              <div style="border:0;"
                                *ngIf="forViewSelectedCard != null && forViewSelectedCard.status != 3" class="card">
                                <div class=" verifiaction-proccess-card-information-str" style="border:0;">


                                  <div
                                    style="display: inline-flex;align-items: center;float: left; background-color: #f2f2f2; border-radius: 4px; padding: 6px 15px;">
                                    <span class="pull-right"><strong
                                        style="margin-right: 5px;">{{forViewSelectedCard?.card_no_masked}}</strong>({{forViewSelectedCard?.brand}})</span>
                                  </div>
                                  <button style="float: right;" class="btn btn-danger btn-sm btn-bg-new-red"
                                    data-toggle="modal" data-target="#deleteCreditCard">Delete <i
                                      class="far fa-trash-alt"></i></button>




                                  <!-- Modal -->
                                  <div class="modal fade" id="deleteCreditCard" tabindex="-1"
                                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered">
                                      <div class="modal-content">
                                        <div class="modal-header">
                                          <h5 class="modal-title" id="exampleModalLabel">Are you sure?
                                          </h5>
                                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                          </button>
                                        </div>
                                        <div class="modal-body">
                                          <p
                                            style="color: #3d3d3d;text-align: center;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                                            Are you sure to delete your
                                            <strong>{{forViewSelectedCard?.brand}}</strong> credit
                                            card:
                                            <strong>{{forViewSelectedCard?.card_no_masked}}</strong>
                                          </p>
                                        </div>
                                        <div class="modal-footer">
                                          <button type="button" class="btn btn-secondary"
                                            data-dismiss="modal">Close</button>
                                          <button style="float: right;" class="btn btn-danger" data-dismiss="modal"
                                            (click)="deleteCreditCard(forViewSelectedCard)">Delete</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="card-body" *ngIf="forViewSelectedCard"
                                  style="padding: 0; margin-top: 10px;">
                                  <div *ngIf="forViewSelectedCard?.status==0">
                                    <button style="font-size: 16px;font-weight: bold;height: 45px;"
                                      (click)="startCardVerifyStatusZero(forViewSelectedCard)"
                                      class="btn shippn-from-to-area-go-btn">CONFIRM VERIFICATION
                                      AMOUNT</button>
                                  </div>
                                  <div *ngIf="forViewSelectedCard?.status==1">
                                    <form ngNativeValidate [formGroup]="cardVerifyForm">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <p
                                            style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 400;margin-bottom: 5px;">
                                            Please enter the <strong>Verification Code</strong> by checking this charge
                                            from your bank.
                                          </p>
                                        </div>
                                        <div style="margin: auto;">
                                          <div id="otp"
                                            class="inputs d-flex flex-row justify-content-center mt-2 otpInputsWrapper">
                                            <div class="otp-pointer">
                                              <h4>
                                                SHIPPN*
                                              </h4>
                                            </div>
                                            <input formControlName="otpInput1"
                                              onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                              class=" text-center form-control rounded otpInputC" type="text"
                                              id="otpInput1" maxlength="1" (keyup)="onKeyPresOTP($event, 1)" />
                                            <input formControlName="otpInput2"
                                              onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                              class="text-center form-control rounded otpInputC" type="text"
                                              id="otpInput2" maxlength="1" (keyup)="onKeyPresOTP($event, 2)" />
                                            <input formControlName="otpInput3"
                                              onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                              class="text-center form-control rounded otpInputC" type="text"
                                              id="otpInput3" maxlength="1" (keyup)="onKeyPresOTP($event, 3)" />
                                            <input formControlName="otpInput4"
                                              onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                              class="text-center form-control rounded otpInputC" type="text"
                                              id="otpInput4" maxlength="1" (keyup)="onKeyPresOTP($event, 4)" />
                                            <div class="otp-pointer">
                                              <h4>
                                                -CODE
                                              </h4>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-12" style="margin-top: 5px;">
                                          <p style="padding: 10px; margin: 0; text-align: center; font-size: 14px;">
                                            <span style="font-size: 18px;font-weight: 900; color: #f66c37">{{
                                              2 -
                                              forViewSelectedCard.verification_attempts}}</span>
                                            attempts left
                                          </p>
                                        </div>
                                        <div class="col-md-12 text-center">
                                          <button style="font-size: 16px;font-weight: bold;height: 45px;"
                                            (click)="startCardVerifyStatusOne(forViewSelectedCard)"
                                            class="btn shippn-from-to-area-go-btn btn-bg-new-green">Confirm Verification
                                            Code</button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                  <div
                                    *ngIf="forViewSelectedCard?.status == 4 || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2) || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2)">
                                    <h4 style="color:#ec0102; font-size: 18px;">
                                      Failed Verification
                                    </h4>
                                    <p style="font-size:14px; color: #3d3d3d;">
                                      Please add another payment method or contact <a href="/{{lang}}/contact-us">Shippn
                                        Support</a>
                                      for further assistance.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Verification Box -->
                    </div>
                    <!-- Verification Area-->


                    <!-- Add Card Form -->
                    <div style="text-align: center;" class="col-md-12" *ngIf="forViewSelectedCard == null">
                      <!-- Card Add Form -->
                      <div style="max-width: 600px;margin-left: auto;margin-right: auto;"
                        class="add-credit-card-prev-and-form-wrapper">


                        <!-- Add Card Form-->
                        <div class="credit-card-form-informations-form">
                          <form ngNativeValidate [formGroup]="creditCardForm" style="max-width: 360px; margin: auto;">
                            <div class="row">
                              <div style="margin-top: 15px;" class="col-12 col-lg-12">
                                <p
                                  style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 0px;">
                                  Name on Card</p>
                                <input (click)="changeCardFlip('front');" style="background-color: white !important;"
                                  type="text" formControlName="nameOnCard"
                                  [ngClass]="{'shippn-border-red':creditCardForm.get('nameOnCard').touched && creditCardForm.get('nameOnCard').invalid}"
                                  placeholder="Name on Card" class="form-control form-control-sm shippn-input">
                              </div>
                              <div style="margin-top: 15px;" class="col-12 col-lg-12">
                                <p
                                  style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 0px;">
                                  Card Number</p>
                                <input (click)="changeCardFlip('front')" style="background-color: white !important;"
                                  type="text" formControlName="cardNumber" maxlength="16"
                                  [ngClass]="{'shippn-border-red':creditCardForm.get('cardNumber').touched && creditCardForm.get('cardNumber').invalid}"
                                  placeholder="1111 2222 3333 4444" class="form-control form-control-sm shippn-input">
                              </div>
                              <div style="margin-top: 15px;" class="col-md-6">
                                <div class="row">
                                  <div class="col-12">
                                    <p
                                      style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 5px;">
                                      Valid Thru</p>
                                  </div>
                                  <div class="col-6 col-lg-6" style="padding-right:5px;">

                                    <div class="select--wrapper">
                                      <i class="fas fa-chevron-down"
                                        style="position: absolute; right: 8px; top: 16px;float: right; color: #3d3d3d;font-size: 12px;"
                                        aria-hidden="true"></i>
                                      <select (click)="changeCardFlip('front')" formControlName="validThruMonth"
                                        style="margin-bottom: 0px; width: 100%; border-radius: 5px;height:42px;"
                                        class="form-control-sm">
                                        <option selected value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-6 col-lg-6 desktop-valid-year-pad">

                                    <div class="select--wrapper">
                                      <i class="fas fa-chevron-down"
                                        style="position: absolute; right: 8px; top: 16px;float: right; color: #3d3d3d;font-size: 12px;"
                                        aria-hidden="true"></i>
                                      <select (click)="changeCardFlip('front')" formControlName="validThruYear"
                                        style="margin-bottom: 2px;margin-top: 0; width: 100%; border-radius: 5px;height:42px;"
                                        class="form-control-sm">
                                        <option value="2024" selected>2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                        <option value="2028">2028</option>
                                        <option value="2029">2029</option>
                                        <option value="2030">2030</option>
                                        <option value="2031">2031</option>
                                        <option value="2032">2032</option>
                                        <option value="2033">2033</option>
                                        <option value="2034">2034</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div style="margin-top: 15px;" class="col-md-6">
                                <p
                                  style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 0px;">
                                  Security Code</p>
                                <input (click)="changeCardFlip('back')" style="background-color: white !important;"
                                  maxlength="4" type="text" formControlName="securityCode"
                                  [ngClass]="{'shippn-border-red':creditCardForm.get('securityCode').touched && creditCardForm.get('securityCode').invalid}"
                                  placeholder="CVC/CCV" class="form-control form-control-sm shippn-input">
                              </div>
                              <div style="margin-top: 20px;" class="col-12">
                                <button *ngIf="!isLoading"
                                  style="width: 100%;font-size: 16px;font-weight: bold;height: 45px;"
                                  (click)="addNewCard()" class="btn shippn-from-to-area-go-btn">ADD CARD</button>
                                <button *ngIf="isLoading"
                                  style="background-image: url(../../assets/img/loading-white.gif);background-repeat: no-repeat;background-position: center;height: 45px;width: 100%;"
                                  class="btn shippn-from-to-area-go-btn"></button>
                              </div>
                            </div>
                          </form>
                        </div>

                        <!-- Card Prev -->
                        <div class="add-credit-card-form-preview-of-credit-card">
                          <div class="credit-card-container preload">
                            <div style="transition: transform 0.6s !important;" [ngClass]="{'flipped':!isShowCardFront}"
                              class="creditcard">
                              <div (click)="changeCardFlip('back')" class="front">
                                <div id="ccsingle"></div>
                                <svg version="1.1" id="cardfront" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 750 471"
                                  style="enable-background:new 0 0 750 471;" xml:space="preserve">
                                  <g id="Front">
                                    <g id="CardBackground">
                                      <g id="Page-1_1_">
                                        <g id="amex_1_">
                                          <path id="Rectangle-1_1_" class="lightcolor grey" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                                  C0,17.9,17.9,0,40,0z" />
                                        </g>
                                      </g>
                                      <path class="darkcolor greydark"
                                        d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z" />
                                    </g>
                                    <text transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber"
                                      class="st2 st3 st4">{{creditCardForm.get('cardNumber').value}}</text>
                                    <text transform="matrix(1 0 0 1 54.1064 428.1723)" id="svgname"
                                      class="st2 st5 st6">{{creditCardForm.get('nameOnCard').value}}</text>
                                    <text transform="matrix(1 0 0 1 54.1074 389.8793)" class="st7 st5 st8">cardholder
                                      name</text>
                                    <text transform="matrix(1 0 0 1 479.7754 388.8793)"
                                      class="st7 st5 st8">expiration</text>
                                    <text transform="matrix(1 0 0 1 65.1054 241.5)" class="st7 st5 st8">card
                                      number</text>
                                    <g>
                                      <text transform="matrix(1 0 0 1 574.4219 433.8095)" id="svgexpire"
                                        class="st2 st5 st9">{{creditCardForm.get('validThruMonth').value}}/{{creditCardForm.get('validThruYear').value}}</text>
                                      <text transform="matrix(1 0 0 1 479.3848 417.0097)"
                                        class="st2 st10 st11">VALID</text>
                                      <text transform="matrix(1 0 0 1 479.3848 435.6762)"
                                        class="st2 st10 st11">THRU</text>
                                      <polygon class="st2" points="554.5,421 540.4,414.2 540.4,427.9 		" />
                                    </g>
                                    <g id="cchip">
                                      <g>
                                        <path class="st2" d="M168.1,143.6H82.9c-10.2,0-18.5-8.3-18.5-18.5V74.9c0-10.2,8.3-18.5,18.5-18.5h85.3
                              c10.2,0,18.5,8.3,18.5,18.5v50.2C186.6,135.3,178.3,143.6,168.1,143.6z" />
                                      </g>
                                      <g>
                                        <g>
                                          <rect x="82" y="70" class="st12" width="1.5" height="60" />
                                        </g>
                                        <g>
                                          <rect x="167.4" y="70" class="st12" width="1.5" height="60" />
                                        </g>
                                        <g>
                                          <path class="st12" d="M125.5,130.8c-10.2,0-18.5-8.3-18.5-18.5c0-4.6,1.7-8.9,4.7-12.3c-3-3.4-4.7-7.7-4.7-12.3
                                  c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.5c0,4.6-1.7,8.9-4.7,12.3c3,3.4,4.7,7.7,4.7,12.3
                                  C143.9,122.5,135.7,130.8,125.5,130.8z M125.5,70.8c-9.3,0-16.9,7.6-16.9,16.9c0,4.4,1.7,8.6,4.8,11.8l0.5,0.5l-0.5,0.5
                                  c-3.1,3.2-4.8,7.4-4.8,11.8c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9c0-4.4-1.7-8.6-4.8-11.8l-0.5-0.5l0.5-0.5
                                  c3.1-3.2,4.8-7.4,4.8-11.8C142.4,78.4,134.8,70.8,125.5,70.8z" />
                                        </g>
                                        <g>
                                          <rect x="82.8" y="82.1" class="st12" width="25.8" height="1.5" />
                                        </g>
                                        <g>
                                          <rect x="82.8" y="117.9" class="st12" width="26.1" height="1.5" />
                                        </g>
                                        <g>
                                          <rect x="142.4" y="82.1" class="st12" width="25.8" height="1.5" />
                                        </g>
                                        <g>
                                          <rect x="142" y="117.9" class="st12" width="26.2" height="1.5" />
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                  <g id="Back">
                                  </g>
                                </svg>
                              </div>
                              <div (click)="changeCardFlip('front')" class="back">
                                <svg version="1.1" id="cardback" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 750 471"
                                  style="enable-background:new 0 0 750 471;" xml:space="preserve">
                                  <g id="Front">
                                    <line class="st0" x1="35.3" y1="10.4" x2="36.7" y2="11" />
                                  </g>
                                  <g id="Back">
                                    <g id="Page-1_2_">
                                      <g id="amex_2_">
                                        <path id="Rectangle-1_2_" class="darkcolor greydark" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                              C0,17.9,17.9,0,40,0z" />
                                      </g>
                                    </g>
                                    <rect y="61.6" class="st2" width="750" height="78" />
                                    <g>
                                      <path class="st3" d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5
                          C707.1,246.4,704.4,249.1,701.1,249.1z" />
                                      <rect x="42.9" y="198.6" class="st4" width="664.1" height="10.5" />
                                      <rect x="42.9" y="224.5" class="st4" width="664.1" height="10.5" />
                                      <path class="st5"
                                        d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z" />
                                    </g>
                                    <text transform="matrix(1 0 0 1 621.999 227.2734)" id="svgsecurity"
                                      class="st6 st7">{{creditCardForm.get('securityCode').value}}</text>
                                    <g class="st8">
                                      <text transform="matrix(1 0 0 1 518.083 280.0879)" class="st9 st6 st10">security
                                        code</text>
                                    </g>
                                    <rect x="58.1" y="378.6" class="st11" width="375.5" height="13.5" />
                                    <rect x="58.1" y="405.6" class="st11" width="421.7" height="13.5" />
                                    <text transform="matrix(1 0 0 1 59.5073 228.6099)" id="svgnameback"
                                      class="st12 st13">{{creditCardForm.get('nameOnCard').value}}</text>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div class="add-credit-card-form-payment-rsel"
                            style=" max-width: 360px; margin: 20px auto 0; padding-left: 0!important; display: flex; justify-content: space-between;">
                            <div style="display: flex; justify-content: space-between; padding-left: 0!important;"
                              class="col-md-9 col-9">
                              <img style="width: 40px;" src="../assets/img/svg-original-colors/payment-visa.svg"
                                alt="Visa Payment SVG Logo">
                              <img style="width: 55px;" src="../assets/img/svg-original-colors/payment-paypal.svg"
                                alt="PayPal Payment SVG Logo">
                              <img style="width:32px;"
                                src="../assets/img/svg-original-colors/payment-american-express.svg"
                                alt="American Express Payment SVG Logo">

                              <img style="width: 36px;"
                                src="../assets/img/svg-original-colors/payment-mastercard-logo.svg"
                                alt="Mastercard Payment SVG Logo">
                            </div>
                            <div style="text-align: center;display: flex; padding: 0;" class="col-md-3 col-3">
                              <img style="width: 100%;" src="../assets/img/svg-original-colors/powered-by-stripe.svg"
                                alt="Powered by stripe SVG badge ">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Credit Card -->
                    <!-- Add Credit Card -->
                  </div>






                  <div class="row" [ngClass]="isPaypal ? '':'hidden'">
                    <div class="col-md-12">
                      <div class="credit-card-area" style="text-align: left;margin-left: auto;margin-right: auto;">
                        <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 400;margin-bottom: 5px;"
                          class="mobile-font-14px">
                           You will be charged <strong translate="no">$ 0.50</strong> to verify your payment method. <br>
                          This will be refunded back to you once verification is completed.</p>
                        <div
                          style=" max-width: 360px; margin: 20px auto 0; padding-left: 0!important; display: flex; justify-content: center; align-items: center;">
                          <ngx-paypal [config]="payPalConfig"></ngx-paypal>
                        </div>
                        <div *ngIf="errorMessagePaypal" class="row">
                          <div style="margin-top: 10px;" class="col-12">
                            <div class="alert alert-danger">
                              <p style="margin-bottom: 0px;text-align: left;font-size: 16px;font-weight: 300;">
                                {{errorMessagePaypal}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" [ngClass]="isExpress ? '':'hidden'" *ngIf="!browserIsFirefox">
                    <div class="col-md-12">
                      <div class="credit-card-area" style="text-align: left;margin-left: auto;margin-right: auto;">
                        <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 400;margin-bottom: 5px;"
                          class="mobile-font-14px">
                           You will be charged <strong translate="no">$ 0.50</strong> to verify your payment method. <br>
                          This will be refunded back to you once verification is completed.</p>                          
                        <div style=" max-width: 360px; margin: 20px auto 0; padding-left: 0!important; display: flex; justify-content: center; align-items: center;">
                          <div id="express-checkout-element">
                          </div>
                          

                        </div>
                      </div>
                    </div>
                  </div>





                </div>
              </div>
            </div>

          </section>

          <section class="section-shipment-details">

            <div class="row">
              <div class="col-md-12">
                <h1 class="shippn-page-title">
                  Shipment Details
                </h1>
              </div>
            </div>
            <div class="row">
              <div style="padding: 0 15px;">
                <div>
                  <form ngNativeValidate [formGroup]="form">
                    <div class="row">
                      <div class="col-12 col-lg-12">
                        <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                          I want
                          to ship my package to</p>
                        <div class="select--wrapper">
                          <i class="fas fa-chevron-down"
                            style="position: absolute; right: 10px!important; top: 18px!important;float: right; color: #3d3d3d;font-size: 12px;"
                            aria-hidden="true"></i>
                          <select (change)="calculatePrice()" formControlName="shipTo"
                            style="margin-top: 5px; margin-bottom: 5px; width: 100%; border-radius: 5px;height:40px;"
                            class="form-control-sm">
                            <option value="{{country.code}}" *ngFor="let country of allCountries">{{country.name}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-12 col-lg-12 m-mt-15" style="margin-top: 15px;">
                        <p style="color: #3d3d3d;text-align: left;font-size: 15px;font-weight: 500;margin-bottom: 8px;">
                          Please enter your package information. <span style="font-weight: 300;">(width, height, length,
                            estimated weight)</span>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-lg-12">
                        <div>
                          <div class="shipment-details-dimension-input-group">
                            <!-- <label class="shippn-form-label shippn-shipment-details-form-label">
                              Units
                            </label> -->
                            <mat-radio-group aria-label="Select an option"
                              class="shipment-details-package-information-radio-group" formControlName="dimensionMetric">
                              <mat-radio-button *ngIf="form?.controls?.dimensionMetric"  [checked]="form?.controls?.dimensionMetric?.value === 'lbs'"
                                (change)="changeDimensionsUnit('lbs')"  type="radio"
                                name="dimensionMetric" value="lbs">lbs / inch</mat-radio-button>
                              <mat-radio-button *ngIf="form?.controls?.dimensionMetric"  [checked]="form?.controls?.dimensionMetric?.value === 'kg'"
                                (change)="changeDimensionsUnit('kg')"  type="radio"
                                name="dimensionMetric" value="kg"
                                class="ng-pristine ng-untouched ng-valid ng-not-empty">kg /
                                cm</mat-radio-button>
                            </mat-radio-group>
                          </div>
                        </div>

                        <div class="shipment-details-dimension-input-group-list element-3">
                          <div class=" shipment-details-dimension-input-group">
                            <label class="shippn-form-label shippn-shipment-details-form-label">
                              Width
                            </label>
                            <div class="shipment-details-input-group input-group">
                              <input (keyup)="calculatePrice()" type="number" formControlName="width"
                                [ngClass]="{'shippn-border-red':form.get('width').touched && form.get('width').invalid}"
                                placeholder="0" class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                              <div class="input-group-append">
                                <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                  <span *ngIf="form.controls.dimensionUnit.value == 'inch'">inch</span>
                                  <span *ngIf="form.controls.dimensionUnit.value == 'cm'">cm</span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="shippn-padding-none shipment-details-dimension-input-group">
                            <label class="shippn-form-label shippn-shipment-details-form-label">
                              Height
                            </label>
                            <div class="shipment-details-input-group input-group">
                              <input (keyup)="calculatePrice()" type="number" formControlName="height"
                                [ngClass]="{'shippn-border-red':form.get('height').touched && form.get('height').invalid}"
                                placeholder="0" class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                              <div class="input-group-append">
                                <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                  <span *ngIf="form.controls.dimensionUnit.value == 'inch'">inch</span>
                                  <span *ngIf="form.controls.dimensionUnit.value == 'cm'">cm</span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="shipment-details-dimension-input-group">
                            <label class="shippn-form-label shippn-shipment-details-form-label">
                              Length
                            </label>
                            <div class="shipment-details-input-group input-group">
                              <input (keyup)="calculatePrice()" type="number" formControlName="length"
                                [ngClass]="{'shippn-border-red':form.get('length').touched && form.get('length').invalid}"
                                placeholder="0" class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                              <div class="input-group-append">
                                <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                  <span *ngIf="form.controls.dimensionUnit.value == 'inch'">inch</span>
                                  <span *ngIf="form.controls.dimensionUnit.value == 'cm'">cm</span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="shipment-details-dimension-input-group">
                            <label class="shippn-form-label shippn-shipment-details-form-label">
                              Weight
                            </label>
                            <div class="shipment-details-input-group input-group">
                              <input (keyup)="calculatePrice()" type="number" formControlName="weight"
                                [ngClass]="{'shippn-border-red':form.get('weight').touched && form.get('weight').invalid}"
                                placeholder="0" class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                              <div class="input-group-append">
                                <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                                  <span *ngIf="form.controls.weightUnit.value == 'lbs'">lbs</span>
                                  <span *ngIf="form.controls.weightUnit.value == 'kg'">kg</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 shippn-promo-code-wrapper">
                        <div class="promo-code-input-wrapper">
                          <label class="shippn-form-label shippn-shipment-details-form-label">
                            Discount Code
                          </label>
                          <div class="shipment-details-input-group input-group">
                            <input type="text" formControlName="promoCode"
                              placeholder="Discount Code" class="form-control form-control-sm shippn-input promo-input">
                          </div>
                        </div>

                        <div class="promo-code-btn-wrapper"> 
                          <button class="btn btn-dark" (click)="calculatePrice(true)">APPLY CODE</button>
                        </div>
                      </div>

                      <div class="col-12 mobile-get-address-and-show-price-wrapper" style="margin-top: 20px;">
                        <div class="row">
                          <div class="col-12 col-lg-12" [hidden]="countryFrom == 'US' && countryTo == 'TR'">
                            <div class="best-shipping-cost-wrapper">

                              <div>
                                <h3
                                  style="color: #3d3d3d;font-size: 15px;font-weight: 500;margin: 0;margin-bottom: 5px;">
                                  Best Shipping Cost</h3>
                                <h3 style="color: #3d3d3d;font-size: 14px;font-weight: 300;margin: 0;">
                                  (Customs & duty not included)
                                </h3>
                              </div>

                              <div style="text-align: right;">
                                <h5
                                  style="font-size: 16px;font-weight: bold;color: #e60000;margin-bottom: 0px;margin-top: 5px; text-decoration: line-through;"
                                  *ngIf="isThereADiscount && oldPriceText > 0">
                                  {{oldPriceText | number:'1.2-2'}} USD</h5>
                                <h6></h6>
                                <h4
                                  style="font-size: 22px;font-weight: bold;color: white;margin-bottom: 0px;margin-top: 5px;"
                                  translate="no" [ngStyle]="{'color': isThereADiscount && oldPriceText > 0 ? '#0d9a0d':
                                  '#3d3d3d'}">
                                  {{priceText | number:'1.2-2'}} USD</h4>
                              </div>

                            </div>
                          </div>
                          <div class="col-12 col-lg-12" style="margin-top: 10px;"
                            [hidden]="countryFrom == 'US' && countryTo == 'TR'">
                            <button style="width: 100%; padding:12px!important;font-size: 16px;font-weight: bold;"
                              (click)="getAddress()" class="btn shippn-from-to-area-go-btn get-address-btn">GET ADDRESS</button>
                          </div>
                        </div>
                      </div>

                      <div style="margin-top: 10px;" class="col-12 col-lg-12">

                        <div class="row">
                          <div class="col-12 payment-validation-for-mobile" id="paymentValidationAreaMobile">

                            <p style="color:#3d3d3d; font-weight: 600; margin: 0 0 10px; font-size: 15px;">
                              Payment Validation
                            </p>
                            <div [ngClass]="isPaymentValidation ? 'verified-payment-validation': ''">
                              <p style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 300;margin-bottom: 10px;"
                                *ngIf="isPaymentValidation == true">
                                You have a verified payment method. You can continue and get the host’s address.</p>

                              <p
                                style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 300;margin-bottom: 10px;">
                                You won’t be charged now. You will pay the shipping fee
                                after the package arrives at your host’s address.<br>
                              </p>
                            </div>

                            <div class="item-details-section-payment-validation-methods-wrapper" [ngClass]="{'element-3v': !browserIsFirefox,
                                'element-2v': browserIsFirefox}"
                              *ngIf="isPaymentValidation == false">
                              <div class="item-details-section-payment-validation-methods-wrapper-credit-card"
                                [ngClass]="paymentValidationNeeded ? 'with-red-border': ''">
                                <button
                                  (click)="isPaypal = false; isExpress = false; isCreditCard = true; paymentValidationNeeded = false "
                                  [ngClass]="isCreditCard == true ? 'active' : ''"
                                  class="radio-inlie payment-method-radio" data-toggle="modal"
                                  data-target="#addCardStartingModal" id="addCardSectionButton"></button>
                                <span style="cursor: pointer;font-size: 12px;display: flex;align-items: center;gap: 5px;white-space:nowrap;"
                                  (click)="isPaypal = false;isExpress = false; isCreditCard = true; paymentValidationNeeded = false"
                                  data-toggle="modal" data-target="#addCardStartingModal" id="addCardSectionButton">Credit Card <i class="fas fa-credit-card" style="color:#f69e1a;"></i>
                                </span>
                              </div>

                              <div class="item-details-section-payment-validation-methods-wrapper-paypal"
                                [ngClass]="paymentValidationNeeded ? 'with-red-border': ''">
                                <button (click)="isPaypal = true; isExpress = false; isCreditCard = false; paymentValidationNeeded = false"
                                  [ngClass]="isPaypal == true ? 'active' : ''"
                                  class="radio-inlie payment-method-radio"></button>
                                <span (click)="isPaypal = true; isExpress = false; isCreditCard = false; paymentValidationNeeded = false"
                                  style="cursor: pointer;">
                                  <img src="assets/img/svg-original-colors/payment-paypal.svg" alt=""
                                    width="60px"></span>
                              </div>

                              <div class="item-details-section-payment-validation-methods-wrapper-paypal"
                              [ngClass]="{
                                'with-red-border': paymentValidationNeeded,
                              }" *ngIf="!browserIsFirefox">
                                <button (click)="isExpress = true; isPaypal = false; isCreditCard = false; paymentValidationNeeded = false; mountExpressCheckout();"
                                  [ngClass]="isExpress == true ? 'active' : ''"
                                  class="radio-inlie payment-method-radio"></button>
                                <span (click)="isExpress = true; isPaypal = false; isCreditCard = false; paymentValidationNeeded = false; mountExpressCheckout();" style="cursor: pointer; display: flex;align-items: center;gap: 5px;">
                                  <img src="assets/img/svg-original-colors/gpay.svg" alt="" height="14px">
                                  <div class="divider-black"></div>
                                  <img src="assets/img/svg-original-colors/link_logo.png" alt="" height="14px">
                                  </span>
                              </div>


                            </div>
                            <div class="item-details-section-payment-validation-method-selected-wrapper"
                              *ngIf="isPaymentValidation == false && (isPaypal || isCreditCard || isExpress)">
                              <div class="row" [ngClass]="isCreditCard ? '':'hidden'">
                                <!-- Verification Area -->
                                <div class="col-md-12" style="margin-left: auto;margin-right: auto;"
                                  *ngIf="forViewSelectedCard != null && forViewSelectedCard.status != 3">
                                  <p style="padding: 0; font-size: 14px;"
                                    [ngClass]="{'hide': forViewSelectedCard?.status == 4 || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2) || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2)}">
                                    <span style="color:#3aa23c; font-size: 16px;">You have added a new card.</span>
                                    <br />
                                    We need to verify this card before it can be used on Shippn. <br />
                                    We have charged <strong translate="no">$0.50</strong> to this card.
                                    <br /> <br />
                                    You will see this charge as <strong translate="no">"SHIPPN* XXXX-CODE"</strong> on
                                    your
                                    credit
                                    card
                                    statement.
                                  </p>
                                  <!-- Verification Box -->
                                  <div *ngIf="forViewSelectedCard != null && forViewSelectedCard.status != 3"
                                    style="padding: 0;">
                                    <div class="row">
                                      <div class="col-md-12 verification-box-mobile-width-fixer">
                                        <div>
                                          <div style="border:0;"
                                            *ngIf="forViewSelectedCard != null && forViewSelectedCard.status != 3"
                                            class="card">
                                            <div class=" verifiaction-proccess-card-information-str" style="border:0;">


                                              <div
                                                style="display: inline-flex;align-items: center;float: left; background-color: #f2f2f2; border-radius: 4px; padding: 6px 15px;">
                                                <span class="pull-right"><strong
                                                    style="margin-right: 5px;">{{forViewSelectedCard?.card_no_masked}}</strong>({{forViewSelectedCard?.brand}})</span>
                                              </div>
                                              <button style="float: right;" class="btn btn-danger btn-sm btn-bg-new-red"
                                                data-toggle="modal" data-target="#deleteCreditCard">Delete <i
                                                  class="far fa-trash-alt"></i></button>




                                              <!-- Modal -->
                                              <div class="modal fade" id="deleteCreditCard" tabindex="-1"
                                                aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                <div class="modal-dialog modal-dialog-centered">
                                                  <div class="modal-content">
                                                    <div class="modal-header">
                                                      <h5 class="modal-title" id="exampleModalLabel">Are you sure?
                                                      </h5>
                                                      <button type="button" class="close" data-dismiss="modal"
                                                        aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                      </button>
                                                    </div>
                                                    <div class="modal-body">
                                                      <p
                                                        style="color: #3d3d3d;text-align: center;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                                                        Are you sure to delete your
                                                        <strong>{{forViewSelectedCard?.brand}}</strong> credit
                                                        card:
                                                        <strong>{{forViewSelectedCard?.card_no_masked}}</strong>
                                                      </p>
                                                    </div>
                                                    <div class="modal-footer">
                                                      <button type="button" class="btn btn-secondary"
                                                        data-dismiss="modal">Close</button>
                                                      <button style="float: right;" class="btn btn-danger"
                                                        data-dismiss="modal"
                                                        (click)="deleteCreditCard(forViewSelectedCard)">Delete</button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="card-body" *ngIf="forViewSelectedCard"
                                              style="padding: 0; margin-top: 10px;">
                                              <div *ngIf="forViewSelectedCard?.status==0">
                                                <button style="font-size: 16px;font-weight: bold;height: 45px;"
                                                  (click)="startCardVerifyStatusZero(forViewSelectedCard)"
                                                  class="btn shippn-from-to-area-go-btn">CONFIRM VERIFICATION
                                                  AMOUNT</button>
                                              </div>
                                              <div *ngIf="forViewSelectedCard?.status==1">
                                                <form ngNativeValidate [formGroup]="cardVerifyForm">
                                                  <div class="row">
                                                    <div class="col-md-12">
                                                      <p
                                                        style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 400;margin-bottom: 5px;">
                                                        Please enter the <strong>Verification Code</strong> by checking
                                                        this
                                                        charge from your bank.
                                                      </p>
                                                    </div>
                                                    <div style="margin: auto;">
                                                      <div id="otp"
                                                        class="inputs d-flex flex-row justify-content-center mt-2 otpInputsWrapper">
                                                        <div class="otp-pointer">
                                                          <h4>
                                                            SHIPPN*
                                                          </h4>
                                                        </div>
                                                        <input formControlName="otpInput1"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class=" text-center form-control rounded otpInputC"
                                                          type="text" id="otpInput1" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 1)" />
                                                        <input formControlName="otpInput2"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput2" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 2)" />
                                                        <input formControlName="otpInput3"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput3" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 3)" />
                                                        <input formControlName="otpInput4"
                                                          onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                                                          class="text-center form-control rounded otpInputC" type="text"
                                                          id="otpInput4" maxlength="1"
                                                          (keyup)="onKeyPresOTP($event, 4)" />
                                                        <div class="otp-pointer">
                                                          <h4>
                                                            -CODE
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="col-md-12" style="margin-top: 5px;">
                                                      <p
                                                        style="padding: 10px; margin: 0; text-align: center; font-size: 14px;">
                                                        <span
                                                          style="font-size: 18px;font-weight: 900; color: #f66c37">{{
                                                          2 -
                                                          forViewSelectedCard.verification_attempts}}</span>
                                                        attempts left
                                                      </p>
                                                    </div>
                                                    <div class="col-md-12 text-center">
                                                      <button style="font-size: 16px;font-weight: bold;height: 45px;"
                                                        (click)="startCardVerifyStatusOne(forViewSelectedCard)"
                                                        class="btn shippn-from-to-area-go-btn btn-bg-new-green">Confirm
                                                        Verification Code</button>
                                                    </div>
                                                  </div>
                                                </form>
                                              </div>
                                              <div
                                                *ngIf="forViewSelectedCard?.status == 4 || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2) || (forViewSelectedCard?.status == 2 && forViewSelectedCard?.verification_attempts >= 2)">
                                                <h4 style="color:#ec0102; font-size: 18px;">
                                                  Failed Verification
                                                </h4>
                                                <p style="font-size:14px; color: #3d3d3d;">
                                                  Please add another payment method or contact <a
                                                    href="/{{lang}}/contact-us">Shippn
                                                    Support</a>
                                                  for further assistance.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Verification Box -->
                                </div>
                                <!-- Verification Area-->


                                <!-- Add Card Form -->
                                <div style="text-align: center;" class="col-md-12" *ngIf="forViewSelectedCard == null">
                                  <!-- Card Add Form -->
                                  <div style="max-width: 600px;margin-left: auto;margin-right: auto;"
                                    class="add-credit-card-prev-and-form-wrapper">


                                    <!-- Add Card Form-->
                                    <div class="credit-card-form-informations-form">
                                      <form ngNativeValidate [formGroup]="creditCardForm"
                                        style="max-width: 360px; margin: auto;">
                                        <div class="row">
                                          <div style="margin-top: 15px;" class="col-12 col-lg-12">
                                            <p
                                              style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 0px;">
                                              Name on Card</p>
                                            <input (click)="changeCardFlip('front');"
                                              style="background-color: white !important;" type="text"
                                              formControlName="nameOnCard"
                                              [ngClass]="{'shippn-border-red':creditCardForm.get('nameOnCard').touched && creditCardForm.get('nameOnCard').invalid}"
                                              placeholder="Name on Card"
                                              class="form-control form-control-sm shippn-input">
                                          </div>
                                          <div style="margin-top: 15px;" class="col-12 col-lg-12">
                                            <p
                                              style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 0px;">
                                              Card Number</p>
                                            <input (click)="changeCardFlip('front')"
                                              style="background-color: white !important;" type="text"
                                              formControlName="cardNumber" maxlength="16"
                                              [ngClass]="{'shippn-border-red':creditCardForm.get('cardNumber').touched && creditCardForm.get('cardNumber').invalid}"
                                              placeholder="1111 2222 3333 4444"
                                              class="form-control form-control-sm shippn-input">
                                          </div>
                                          <div style="margin-top: 15px;" class="col-md-6">
                                            <div class="row">
                                              <div class="col-12">
                                                <p
                                                  style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 5px;">
                                                  Valid Thru</p>
                                              </div>
                                              <div class="col-6 col-lg-6" style="padding-right:5px;">

                                                <div class="select--wrapper">
                                                  <i class="fas fa-chevron-down"
                                                    style="position: absolute; right: 8px; top: 16px;float: right; color: #3d3d3d;font-size: 12px;"
                                                    aria-hidden="true"></i>
                                                  <select (click)="changeCardFlip('front')"
                                                    formControlName="validThruMonth"
                                                    style="margin-bottom: 0px; width: 100%; border-radius: 5px;height:42px;"
                                                    class="form-control-sm">
                                                    <option selected value="01">01</option>
                                                    <option value="02">02</option>
                                                    <option value="03">03</option>
                                                    <option value="04">04</option>
                                                    <option value="05">05</option>
                                                    <option value="06">06</option>
                                                    <option value="07">07</option>
                                                    <option value="08">08</option>
                                                    <option value="09">09</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="col-6 col-lg-6 desktop-valid-year-pad">

                                                <div class="select--wrapper">
                                                  <i class="fas fa-chevron-down"
                                                    style="position: absolute; right: 8px; top: 16px;float: right; color: #3d3d3d;font-size: 12px;"
                                                    aria-hidden="true"></i>
                                                  <select (click)="changeCardFlip('front')"
                                                    formControlName="validThruYear"
                                                    style="margin-bottom: 2px;margin-top: 0; width: 100%; border-radius: 5px;height:42px;"
                                                    class="form-control-sm">
                                                    <option value="2024" selected>2024</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2027">2027</option>
                                                    <option value="2028">2028</option>
                                                    <option value="2029">2029</option>
                                                    <option value="2030">2030</option>
                                                    <option value="2031">2031</option>
                                                    <option value="2032">2032</option>
                                                    <option value="2033">2033</option>
                                                    <option value="2034">2034</option>
                                                  </select>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div style="margin-top: 15px;" class="col-md-6">
                                            <p
                                              style="color: #3d3d3d;text-align: left;font-size: 14px;font-weight: 500;margin-bottom: 0px;">
                                              Security Code</p>
                                            <input (click)="changeCardFlip('back')"
                                              style="background-color: white !important;" maxlength="4" type="text"
                                              formControlName="securityCode"
                                              [ngClass]="{'shippn-border-red':creditCardForm.get('securityCode').touched && creditCardForm.get('securityCode').invalid}"
                                              placeholder="CVC/CCV" class="form-control form-control-sm shippn-input">
                                          </div>
                                          <div style="margin-top: 20px;" class="col-12">
                                            <button *ngIf="!isLoading"
                                              style="width: 100%;font-size: 16px;font-weight: bold;height: 45px;"
                                              (click)="addNewCard()" class="btn shippn-from-to-area-go-btn">ADD
                                              CARD</button>
                                            <button *ngIf="isLoading"
                                              style="background-image: url(../../assets/img/loading-white.gif);background-repeat: no-repeat;background-position: center;height: 45px;width: 100%;"
                                              class="btn shippn-from-to-area-go-btn"></button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>

                                    <!-- Card Prev -->
                                    <div class="add-credit-card-form-preview-of-credit-card">
                                      <div class="credit-card-container preload">
                                        <div style="transition: transform 0.6s !important;"
                                          [ngClass]="{'flipped':!isShowCardFront}" class="creditcard">
                                          <div (click)="changeCardFlip('back')" class="front">
                                            <div id="ccsingle"></div>
                                            <svg version="1.1" id="cardfront" xmlns="http://www.w3.org/2000/svg"
                                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                              viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;"
                                              xml:space="preserve">
                                              <g id="Front">
                                                <g id="CardBackground">
                                                  <g id="Page-1_1_">
                                                    <g id="amex_1_">
                                                      <path id="Rectangle-1_1_" class="lightcolor grey" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                                              C0,17.9,17.9,0,40,0z" />
                                                    </g>
                                                  </g>
                                                  <path class="darkcolor greydark"
                                                    d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z" />
                                                </g>
                                                <text transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber"
                                                  class="st2 st3 st4">{{creditCardForm.get('cardNumber').value}}</text>
                                                <text transform="matrix(1 0 0 1 54.1064 428.1723)" id="svgname"
                                                  class="st2 st5 st6">{{creditCardForm.get('nameOnCard').value}}</text>
                                                <text transform="matrix(1 0 0 1 54.1074 389.8793)"
                                                  class="st7 st5 st8">cardholder
                                                  name</text>
                                                <text transform="matrix(1 0 0 1 479.7754 388.8793)"
                                                  class="st7 st5 st8">expiration</text>
                                                <text transform="matrix(1 0 0 1 65.1054 241.5)" class="st7 st5 st8">card
                                                  number</text>
                                                <g>
                                                  <text transform="matrix(1 0 0 1 574.4219 433.8095)" id="svgexpire"
                                                    class="st2 st5 st9">{{creditCardForm.get('validThruMonth').value}}/{{creditCardForm.get('validThruYear').value}}</text>
                                                  <text transform="matrix(1 0 0 1 479.3848 417.0097)"
                                                    class="st2 st10 st11">VALID</text>
                                                  <text transform="matrix(1 0 0 1 479.3848 435.6762)"
                                                    class="st2 st10 st11">THRU</text>
                                                  <polygon class="st2" points="554.5,421 540.4,414.2 540.4,427.9 		" />
                                                </g>
                                                <g id="cchip">
                                                  <g>
                                                    <path class="st2" d="M168.1,143.6H82.9c-10.2,0-18.5-8.3-18.5-18.5V74.9c0-10.2,8.3-18.5,18.5-18.5h85.3
                                          c10.2,0,18.5,8.3,18.5,18.5v50.2C186.6,135.3,178.3,143.6,168.1,143.6z" />
                                                  </g>
                                                  <g>
                                                    <g>
                                                      <rect x="82" y="70" class="st12" width="1.5" height="60" />
                                                    </g>
                                                    <g>
                                                      <rect x="167.4" y="70" class="st12" width="1.5" height="60" />
                                                    </g>
                                                    <g>
                                                      <path class="st12" d="M125.5,130.8c-10.2,0-18.5-8.3-18.5-18.5c0-4.6,1.7-8.9,4.7-12.3c-3-3.4-4.7-7.7-4.7-12.3
                                              c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.5c0,4.6-1.7,8.9-4.7,12.3c3,3.4,4.7,7.7,4.7,12.3
                                              C143.9,122.5,135.7,130.8,125.5,130.8z M125.5,70.8c-9.3,0-16.9,7.6-16.9,16.9c0,4.4,1.7,8.6,4.8,11.8l0.5,0.5l-0.5,0.5
                                              c-3.1,3.2-4.8,7.4-4.8,11.8c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9c0-4.4-1.7-8.6-4.8-11.8l-0.5-0.5l0.5-0.5
                                              c3.1-3.2,4.8-7.4,4.8-11.8C142.4,78.4,134.8,70.8,125.5,70.8z" />
                                                    </g>
                                                    <g>
                                                      <rect x="82.8" y="82.1" class="st12" width="25.8" height="1.5" />
                                                    </g>
                                                    <g>
                                                      <rect x="82.8" y="117.9" class="st12" width="26.1" height="1.5" />
                                                    </g>
                                                    <g>
                                                      <rect x="142.4" y="82.1" class="st12" width="25.8" height="1.5" />
                                                    </g>
                                                    <g>
                                                      <rect x="142" y="117.9" class="st12" width="26.2" height="1.5" />
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                              <g id="Back">
                                              </g>
                                            </svg>
                                          </div>
                                          <div (click)="changeCardFlip('front')" class="back">
                                            <svg version="1.1" id="cardback" xmlns="http://www.w3.org/2000/svg"
                                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                              viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;"
                                              xml:space="preserve">
                                              <g id="Front">
                                                <line class="st0" x1="35.3" y1="10.4" x2="36.7" y2="11" />
                                              </g>
                                              <g id="Back">
                                                <g id="Page-1_2_">
                                                  <g id="amex_2_">
                                                    <path id="Rectangle-1_2_" class="darkcolor greydark" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                                          C0,17.9,17.9,0,40,0z" />
                                                  </g>
                                                </g>
                                                <rect y="61.6" class="st2" width="750" height="78" />
                                                <g>
                                                  <path class="st3" d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5
                                      C707.1,246.4,704.4,249.1,701.1,249.1z" />
                                                  <rect x="42.9" y="198.6" class="st4" width="664.1" height="10.5" />
                                                  <rect x="42.9" y="224.5" class="st4" width="664.1" height="10.5" />
                                                  <path class="st5"
                                                    d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z" />
                                                </g>
                                                <text transform="matrix(1 0 0 1 621.999 227.2734)" id="svgsecurity"
                                                  class="st6 st7">{{creditCardForm.get('securityCode').value}}</text>
                                                <g class="st8">
                                                  <text transform="matrix(1 0 0 1 518.083 280.0879)"
                                                    class="st9 st6 st10">security
                                                    code</text>
                                                </g>
                                                <rect x="58.1" y="378.6" class="st11" width="375.5" height="13.5" />
                                                <rect x="58.1" y="405.6" class="st11" width="421.7" height="13.5" />
                                                <text transform="matrix(1 0 0 1 59.5073 228.6099)" id="svgnameback"
                                                  class="st12 st13">{{creditCardForm.get('nameOnCard').value}}</text>
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="add-credit-card-form-payment-rsel"
                                        style=" max-width: 360px; margin: 20px auto 0; padding-left: 0!important; display: flex; justify-content: space-between;">
                                        <div
                                          style="display: flex; justify-content: space-between; padding-left: 0!important;"
                                          class="col-md-9 col-9">
                                          <img style="width: 40px;"
                                            src="../assets/img/svg-original-colors/payment-visa.svg"
                                            alt="Visa Payment SVG Logo">
                                          <img style="width: 55px;"
                                            src="../assets/img/svg-original-colors/payment-paypal.svg"
                                            alt="PayPal Payment SVG Logo">
                                          <img style="width:32px;"
                                            src="../assets/img/svg-original-colors/payment-american-express.svg"
                                            alt="American Express Payment SVG Logo">

                                          <img style="width: 36px;"
                                            src="../assets/img/svg-original-colors/payment-mastercard-logo.svg"
                                            alt="Mastercard Payment SVG Logo">
                                        </div>
                                        <div style="text-align: center;display: flex; padding: 0;"
                                          class="col-md-3 col-3">
                                          <img style="width: 100%;"
                                            src="../assets/img/svg-original-colors/powered-by-stripe.svg"
                                            alt="Powered by stripe SVG badge ">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!-- Credit Card -->
                                <!-- Add Credit Card -->
                              </div>
                              <div class="row" [ngClass]="isPaypal ? '':'hidden'">
                                <div class="col-md-12">
                                  <div class="credit-card-area"
                                    style="text-align: left;margin-left: auto;margin-right: auto;">
                                    <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 400;margin-bottom: 5px;"
                                      class="mobile-font-14px">
                                      You will be charged <strong translate="no">$ 0.50</strong> to verify your payment
                                      method. <br>
                                      This will be refunded back to you once verification is completed.</p>
                                    <div
                                      style=" max-width: 360px; margin: 20px auto 0; padding-left: 0!important; display: flex; justify-content: center; align-items: center;">
                                      <ngx-paypal [config]="payPalConfig"></ngx-paypal>
                                    </div>
                                    <div *ngIf="errorMessagePaypal" class="row">
                                      <div style="margin-top: 10px;" class="col-12">
                                        <div class="alert alert-danger">
                                          <p
                                            style="margin-bottom: 0px;text-align: left;font-size: 16px;font-weight: 300;">
                                            {{errorMessagePaypal}}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row" [ngClass]="isExpress ? '':'hidden'" *ngIf="!browserIsFirefox">
                                <div class="col-md-12">
                                  <div class="credit-card-area" style="text-align: left;margin-left: auto;margin-right: auto;">
                                    <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 400;margin-bottom: 5px;"
                                      class="mobile-font-14px">
                                       You will be charged <strong translate="no">$ 0.50</strong> to verify your payment method. <br>
                                      This will be refunded back to you once verification is completed.</p>                          
                                    <div style=" max-width: 360px; margin: 20px auto 0; padding-left: 0!important; display: flex; justify-content: center; align-items: center;">
                                      <div id="express-checkout-element-mobile">
                                      </div>
                                      
            
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12" id="prohibitedItemsArea">
                            <div class="prohibited-and-placing-order-wrapper">
                              <div class="prohibitedCheckBox-wrapper">

                                <input class="form-check-input" formControlName="prohibitedGoodsConfirmation"
                                  type="checkbox" id="prohibitedGoodsCheck">
                                <label style="font-size: 14px;font-weight: 400;" class="form-check-label"
                                  for="prohibitedGoodsCheck" id="prohibitedGoodsCheckLabel"
                                  [ngStyle]="{'color':form.value.prohibitedGoodsConfirmation ? '': '#db1515'}">
                                  I confirm that I am not shipping any prohibited or illegal items via Shippn. <sub
                                    style="font-weight: 300;color: #ff6c36;">
                                    *Required
                                  </sub>
                                </label>
                              </div>

                              <div class="prohibited-expl-are">
                                <p
                                  style="color: #3d3d3d;text-align: left;font-size: 12px;font-weight: 300;margin-bottom: 8px;margin-top: 10px;">
                                  <strong style="font-weight: bold;">Please note that</strong> prohibited items
                                  (Firearms,
                                  explosives, gun parts, illegal
                                  drugs, tobacco/cannabis, alcohol, perishable foods, live animals, perfumes, liquid)
                                  can not
                                  be
                                  shipped using Shippn.
                                </p>

                                <div class="prohibited-items-wrapper">
                                  <img src="../../../assets/img/prohibited-items/no_drugs.svg" alt="No drugs">
                                  <img src="../../../assets/img/prohibited-items/006-no-weapons.webp" alt="no weapons">
                                  <img src="../../../assets/img/prohibited-items/no_liquid.svg" alt="no liquid">
                                  <img src="../../../assets/img/prohibited-items/011-no-plastic-bottles.webp"
                                    alt="no bottles">
                                  <img src="../../../assets/img/prohibited-items/013-no-drinks.webp" alt="no drinks">
                                  <img src="../../../assets/img/prohibited-items/018-no-bomb-1.webp"
                                    alt="no explosives">
                                  <img src="../../../assets/img/prohibited-items/008-no-animals-1.webp" alt="no pets">
                                  <img src="../../../assets/img/prohibited-items/019-no-drugs-4.webp" alt="no drugs">
                                </div>


                                <p style="margin-top: 10px;font-size: 13px;">
                                  By placing your order, you agree to Shippn’s <a href="/{{lang}}/privacy-policy"
                                    target="_blank" style="color: #357ab6;font-weight: bold;">Privacy Policy </a>and<a
                                    href="/{{lang}}/terms" target="_blank" style="color: #357ab6;font-weight: bold;">
                                    Terms &
                                    Conditions</a>.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="errorMessage" style="margin-top: 10px;" class="col-12">
                        <div class="alert alert-danger">
                          <p style="margin-bottom: 0px;text-align: left;font-size: 16px;font-weight: 300;">
                            {{errorMessage}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </section>

        </div>
      </div>
    </div>

  </section>
</section>

<section>
  <div class="container shippn-homepage-container">
    <div class="row">
      <div class="col-12">
        <div class="shippnpilot-main-wrapper-mobile">
          <app-shippnpilot-widget [shippnpilotWidgetType]="'both'"></app-shippnpilot-widget>
        </div>
      </div>
    </div>
  </div>
</section>

<div style="background: #f4f4f4;">
  <div class="container shippn-homepage-container">
    <div class="row">
      <div style="margin-top: 40px;margin-bottom: 40px;" class="col-md-12">
        <h3 style="color: #3d3d3d;font-size: 22px;font-weight: bold;margin-bottom: 15px;">Shipping rates, tax and duties
        </h3>

        <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 5px;">Shippn Cost
          Calculator provides an estimate of the total shipping cost (no hidden fees) to shop and ship your parcels
          globally to your home address. When your package arrives at our host, its weight and dimensions will be
          measured. Then you will pay the shipping fee when confirming your order.Your item may not require customs
          clearance. Customs fees and duties are calculated based on the content and value of your items and your
          country’s regulations. If needed we will give you more information about customs and duties when your
          package
          arrives at our host.For tax and duties information or any other questions, please contact our customer
          service
          team.</p>

        <h3 style="color: #3d3d3d;font-size: 22px;font-weight: bold;margin-bottom: 15px;margin-top: 20px;">Oversized
          Package</h3>

        <p style="color: #3d3d3d;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 5px;">According to
          shipping couriers rules, a package is considered oversized if it exceeds the scale weight of 70kg or in
          excess
          of 120cm with a single dimension. In which case, an additional fixed charge will be added to the final
          shipping charge. For more information about extra charges by shipping couriers click here.</p>

      </div>
    </div>
  </div>
</div>

<!--Add Card Starting Modal -->
<button id="hiddenAddCardModalOpener" data-toggle="modal" data-target="#addCardStartingModal"
  style="display: none!important; visibility: hidden!important; height:0px!important; width: 0px!important;"></button>
<div class="modal fade" id="addCardStartingModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered add-credit-card-warning-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Credit Card Verification</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>
          Credit Card Verification Process
        </h5>

        <p>
          We will charge <strong>$0.50</strong> from your credit card. This charge will be refunded when you
          complete the verification process.
          <br />
          You will see this charge as <strong>"SHIPPN* XXXX-CODE"</strong> on your credit card statement.
        </p>

        <div>
          You'll need to:
          <ul>
            <li>Check your bank/credit card account in 1-2 business days for the verification code.</li>
            <li>Enter the verification code you saw on your credit card statement and click Verify.</li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          style="background-color: #fe6c36;">PROCEED</button>
      </div>
    </div>
  </div>
</div>

<!-- Paypal Verification Waiting Moda-->
<button style="width:0; height:0; display: none;" id="payPalVerificationModalButton" data-toggle="modal"
  data-target="#payPalVerificationModal"></button>
<!-- Modal -->
<div class="modal fade" id="payPalVerificationModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div style="max-width: 600px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background: #3d3d3d;">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
          PayPal Verification </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="text-align: left;max-height: 500px;overflow-y: auto;" class="col-md-12">
          <div style="color: #0f0f0f;font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;"
            *ngIf="!payPalErrorMessage">

            <p style="text-align:center;">
              Waiting for PayPal verification.
            </p>
            <div
              style="background-image: url(../../assets/img/loading-black.gif);background-repeat: no-repeat;background-position: center;height: 35px;width: 100%;">
            </div>

          </div>
          <p *ngIf="payPalErrorMessage"
            style="color: #0f0f0f; font-size: 15px;font-weight: 300;margin-top: 20px;margin-bottom: 20px;">
            {{payPalErrorMessage}}
          </p>

        </div>
      </div>
      <div class="modal-footer">
        <button style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;" data-dismiss="modal"
          class="btn shippn-from-to-area-go-btn" id="paypalVerificationModalCloser">Close</button>
      </div>
    </div>
  </div>
</div>


<button id="nlWarningModalTrigger" [hidden]="true" data-toggle="modal" data-target="#nlWarningModal">Open
  Modal</button>

<!-- Modal -->
<div class="modal fade" data-keyboard="false" data-backdrop="static" id="nlWarningModal" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background: #3d3d3d;" class="modal-header">
        <div style="display: inline-flex;align-items: center;">
          <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
            Please Note That</h5>
        </div>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <p>
                Please note that all chemicals (including ''research chemicals'') are <strong
                  style="color:red">prohibited</strong> in this country. If your package contains any prohibited
                items, your host will dispose of them immediately.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="flex-wrap: wrap; align-items: flex-start;">
        <button class="btn shippn-from-to-area-go-btn" data-dismiss="modal" aria-label="Close">Ok, got it.</button>
      </div>

    </div>
  </div>
</div>


<div class="modal fade" data-keyboard="false" data-backdrop="static" id="editProduct" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background: #3d3d3d;" class="modal-header">
        <div style="display: inline-flex;align-items: center;">
          <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
            Edit Product</h5>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <input type="text" class="form-control" [(ngModel)]="newProductLink">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="flex-wrap: wrap; align-items: flex-start;">
        <button class="btn btn-dark" id="editProductModalCloser" data-dismiss="modal" aria-label="Close">Cancel</button>
        <button class="btn shippn-from-to-area-go-btn" (click)="editProductLink(selectedProduct, newProductLink)"
          aria-label="Close">Update</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" data-keyboard="false" data-backdrop="static" id="deleteProduct" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background: #3d3d3d;" class="modal-header">
        <div style="display: inline-flex;align-items: center;">
          <h5 style="color: white;padding-left: 15px;" class="modal-title" id="exampleModalLabel">
            Delete Product</h5>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="deleting-order-links-list-item">

                <div class="deleting-og-detail-image-of-product">
                  <img src="{{selectedProduct?.image}}" alt="">
                </div>
                <div>
                  <p class="deleting-order-links-list-item-product-link">

                    <span *ngIf="selectedProduct?.name">{{selectedProduct?.name}}</span>
                    <span *ngIf="!selectedProduct?.name">{{selectedProduct?.url}}</span>
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="flex-wrap: wrap; align-items: flex-start;">
        <button class="btn btn-dark" id="deleteProductModalCloser" data-dismiss="modal"
          aria-label="Close">Cancel</button>
        <button class="btn shippn-from-to-area-go-btn" (click)="deleteProductLink(selectedProduct)"
          aria-label="Close">Delete</button>
      </div>

    </div>
  </div>
</div>